<script setup>
import { ref, onMounted } from 'vue';
import UploadDropzone from "@/Components/Uploads/UploadDropzone.vue";
import UploadsList from "@/Components/Uploads/UploadsList.vue";
import { useUploadsStore } from '@/Stores/uploads'
const uploads = useUploadsStore()

const props = defineProps({
    uploads: {
        type: Array,
        default: () => [],
        required: false,
    },
    files: {
        type: Array,
        default: () => [],
        required: false,
    },
	fileable_type: {
		type: String,
		required: true,
	},
	fileable_id: {
		type: Number,
		required: true,
	},
});

const emit = defineEmits([
	'upload-complete'
])

function uploadComplete(file) {
	emit('upload-complete', file)
	removeUploadTimeout(file)
}

function fileDeleted(id) {
	emit('file-deleted', id)
}

function removeUploadTimeout(file) {
	window.setTimeout(function() {
		uploads.removeFile(file)
	}, 1200)
}

const dropzone = ref(null);

onMounted(() => {
    uploads.r.assignBrowse(dropzone.value)
    uploads.r.assignDrop(dropzone.value)
	// add data to the request - each packet gets this data
	uploads.r.updateQuery({
		fileable_type: props.fileable_type, 
		fileable_id: props.fileable_id
	})
})
</script>

<template>
    <SectionCard title="Files" :full-width="true">
		<div ref="dropzone">
        	<UploadDropzone :uploads="uploads.files" @upload-complete="uploadComplete" />
		</div>
        <UploadsList :files="files" @file-deleted="fileDeleted" />
    </SectionCard>
</template>
